import { useQuery } from '@tanstack/react-query';
import { salesApi, hybridApi } from '../services/api';
import { LocationsData } from '../types';

// Product Mix Hook - Using hybrid API for real data
export const useProductMix = (date?: string, storeId?: string) => {
  return useQuery({
    queryKey: ['productMix', date, storeId],
    queryFn: async () => {
      const response = await hybridApi.getProductMix(date, storeId);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Employee Performance Hook - Using hybrid API for real data
export const useEmployeePerformance = (date?: string, storeId?: string) => {
  return useQuery({
    queryKey: ['employeePerformance', date, storeId],
    queryFn: async () => {
      const response = await hybridApi.getEmployeePerformance(date, storeId);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Payment Analysis Hook - Using hybrid API for real data
export const usePaymentAnalysis = (date?: string, storeId?: string) => {
  return useQuery({
    queryKey: ['paymentAnalysis', date, storeId],
    queryFn: async () => {
      const response = await hybridApi.getPaymentMethods(date, storeId);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Locations Hook
export const useLocations = () => {
  return useQuery<LocationsData>({
    queryKey: ['locations'],
    queryFn: async () => {
      const response = await salesApi.getLocations();
      return response.data;
    },
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Modifier Insights Hook
export const useModifierInsights = () => {
  return useQuery({
    queryKey: ['modifierInsights'],
    queryFn: async () => {
      const response = await salesApi.getModifierInsights();
      return response.data;
    },
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};